import { useAsync } from 'react-use';
import { Component as ComponentContainer } from '@styles/layout';
import { GenericComponent } from '@model/content';
import { SectionTitleSizes } from '@components/common/section-title';
import { getDestinationFaqData } from '@components/util/get-destination-faq';
import { DestinationFaqMeta } from '@components/meta/DestinationFaqMeta';
import DestinationFAQ from '@components/destination/DestinationFAQ';

export const DestinationFaqContainer = ({ path, data }: GenericComponent) => {
  if (!path) return null;

  const { value } = useAsync(async () => {
    return data ? data : await getDestinationFaqData(path);
  }, [path]);

  const destinationFaqs = value?.data;

  if (!destinationFaqs?.length) {
    return null;
  }

  return (
    <ComponentContainer>
      <DestinationFaqMeta faqs={destinationFaqs} />
      <DestinationFAQ faqs={destinationFaqs} titleSize={SectionTitleSizes.LARGE} />
    </ComponentContainer>
  );
};
